import { dispatchAmplitudeEvent } from './dispatchAmplitudeEvent'
import type {
  ProductQueryObject,
  StandardObject,
} from './types/amplitudeObjects'

type FeatureObject = {
  locationOnPage?: string | null
  name: string
  type: string
}

type SendProductInformationSelectedEventProps = {
  standardObject: StandardObject | null
  productObject: ProductQueryObject | null
  clickedElement: string
  featureDetailsObject: FeatureObject
  additionalEventData?: Record<string, string>
}

export const sendProductInformationSelectedEvent = ({
  standardObject,
  productObject,
  clickedElement,
  featureDetailsObject,
  additionalEventData,
}: SendProductInformationSelectedEventProps) => {
  if (!standardObject || !productObject) {
    return
  }

  dispatchAmplitudeEvent({
    eventName: 'Product Information Selected',
    eventData: {
      ...standardObject,
      ...featureDetailsObject,
      'product details': [productObject],
      'information tab name': clickedElement,
      ...(additionalEventData && { ...additionalEventData }),
    },
  })
}
